/* eslint-disable no-template-curly-in-string */
/* Copyright (c) 2020-present CloudIO Inc */

// Copy this file to src/componentregistry/components/StringColumn folder
// and import helpRenders into StringColumnManager.ts file
// import { helpRenders } from './StringColumn_Help';

import { ComponentSample, Item } from 'componentregistry';

const page: {
  root: Item<'Page'>;
  canvasGrid: Item<'CanvasGrid'>;
  testAliasLocalDataStore: Item<'LocalDataStore'>;
  renderAsPillStringColumn: Item<'StringColumn'>;
  testAliasDataStoreReference: Item<'DataStoreReference'>;
  withLetterAvatarStringColumn: Item<'StringColumn'>;
  withIconViaFormatFunctionStringColumn: Item<'StringColumn'>;
  withTriggerOnCellClickStringColumn: Item<'StringColumn'>;
  triggerOnCellClick: Item<'TriggerOnCellClick'>;
  showMessage: Item<'ActionShowMessage'>;
  plainTextStringColumn: Item<'StringColumn'>;
  playgroundStringColumn: Item<'StringColumn'>;
} = {
  canvasGrid: {
    children: [
      'playgroundStringColumn',
      'plainTextStringColumn',
      'withLetterAvatarStringColumn',
      'renderAsPillStringColumn',
      'withIconViaFormatFunctionStringColumn',
      'withTriggerOnCellClickStringColumn',
    ],
    itemId: 'canvasGrid',
    parent: 'testAliasDataStoreReference',
    props: {
      rowHeight: 36,
      updatable: {
        type: 'expression',
        value: '$.testAlias.id % 2 === 0',
      },
      sortable: false,
    },
    type: 'CanvasGrid',
  },
  plainTextStringColumn: {
    children: [],
    itemId: 'plainTextStringColumn',
    parent: 'canvasGrid',
    props: {
      label: { type: 'text', value: 'Plain Text' },
      viewAttribute: 'firstName',
    },
    type: 'StringColumn',
  },
  playgroundStringColumn: {
    children: [],
    itemId: 'playgroundStringColumn',
    parent: 'canvasGrid',
    props: {
      bgColorExpression: {
        type: 'expression',
        value: 'getColor($.testAlias.firstName)',
      },
      colorExpression: {
        type: 'expression',
        value: 'getReadableColor(getColor($.testAlias.firstName))',
      },
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Playground' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'firstName',
      width: 155,
    },
    type: 'StringColumn',
  },
  renderAsPillStringColumn: {
    children: [],
    itemId: 'renderAsPillStringColumn',
    parent: 'canvasGrid',
    props: {
      alignment: 'center',
      bgColorExpression: {
        type: 'expression',
        value: 'getColor($.testAlias.firstName)',
      },
      colorExpression: {
        type: 'expression',
        value: 'getReadableColor(getColor($.testAlias.firstName))',
      },
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'Render As Pill w/ Random Colors' },
      renderAsPill: true,
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'firstName',
      width: 237,
    },
    type: 'StringColumn',
  },
  root: {
    children: ['testAliasLocalDataStore', 'testAliasDataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      padding: {
        all: 0,
      },
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
  showMessage: {
    children: [],
    itemId: 'showMessage',
    parent: 'triggerOnCellClick',
    props: {
      message: {
        type: 'expression',
        value: '`Cell with value [${$.testAlias.firstName}] clicked!`',
      },
      type: 'info',
    },
    type: 'ActionShowMessage',
  },
  testAliasDataStoreReference: {
    children: ['canvasGrid'],
    itemId: 'testAliasDataStoreReference',
    parent: 'root',
    props: {
      alias: 'testAlias',
    },
    type: 'DataStoreReference',
  },
  testAliasLocalDataStore: {
    children: [],
    itemId: 'testAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'testAlias',
      dataFormat: 'ts',
      dataSource: 'test',
      tsData:
        "const dateTime = new Date().toISOString();\nconst data = Array.from(Array(10000).keys()).map((_, i) => {\n  const rating = Math.ceil(Math.random() * 5);\n  const n = Math.round(Math.random() * 100);\n  return {\n    id: i,\n    firstName: `Row ${i + 1}`,\n    number: Math.round(Math.random() * 10000) / 100,\n    dateTime,\n    boolean: rating % 2 !== 0,\n    checkbox: rating % 2 ? 'N' : 'Y',\n    percent: Math.random(),\n    gender: rating % 3 === 0 ? 'M' : 'F',\n    rating,\n    imageUrl: `https://picsum.photos/id/${n}/100/100`,\n  };\n});\nreturn data;",
    },
    type: 'LocalDataStore',
  },
  triggerOnCellClick: {
    children: ['showMessage'],
    itemId: 'triggerOnCellClick',
    parent: 'withTriggerOnCellClickStringColumn',
    props: {},
    type: 'TriggerOnCellClick',
  },
  withIconViaFormatFunctionStringColumn: {
    children: [],
    itemId: 'withIconViaFormatFunctionStringColumn',
    parent: 'canvasGrid',
    props: {
      bgColorExpression: {
        type: 'expression',
        value: '',
      },
      colorExpression: {
        type: 'expression',
        value: '',
      },
      formatFunction: 'formatGenderSelect',
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'With Icon Via Format Function' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'firstName',
      width: 215,
    },
    type: 'StringColumn',
  },
  withLetterAvatarStringColumn: {
    children: [],
    itemId: 'withLetterAvatarStringColumn',
    parent: 'canvasGrid',
    props: {
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'With Letter Avatar' },
      renderLetterAvatar: 'on',
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'firstName',
      width: 155,
    },
    type: 'StringColumn',
  },
  withTriggerOnCellClickStringColumn: {
    children: ['triggerOnCellClick'],
    itemId: 'withTriggerOnCellClickStringColumn',
    parent: 'canvasGrid',
    props: {
      bgColorExpression: {
        type: 'expression',
        value: '',
      },
      colorExpression: {
        type: 'expression',
        value: '',
      },
      formatFunction: 'formatGenderSelect',
      insertable: {
        type: 'boolean',
        value: true,
      },
      label: { type: 'text', value: 'With Trigger On Cell Click' },
      updatable: {
        type: 'boolean',
        value: true,
      },
      viewAttribute: 'firstName',
      width: 320,
    },
    type: 'StringColumn',
  },
};

const controller = `import React from 'react';
import { Box } from '@mui/material';
import type { FormatColumnValueFunction, IconValueWithToolTip } from 'cloudio';

const NF = {
  USD: new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }),
};

const formatCurrency: FormatColumnValueFunction = ({ viewAttribute, value, rawValue, record, theme }) => {
  if (typeof rawValue === 'number') {
      return NF.USD.format(rawValue);
  }
  return value;
}

const formatGenderSelect: FormatColumnValueFunction = ({ viewAttribute, value, rawValue, record, theme }) => {
  if (rawValue) {
      let icon: IconValueWithToolTip | undefined;
      switch (rawValue) {
          case 'M':
              icon = { iconName: 'user-hard-hat', color: theme.palette.primary.main, iconType: 'light' };
              break;
          default:
              icon = { iconName: 'user', color: 'pink', iconType: 'light', iconSize: 16, tooltip: \`some tooltip... \${value}\` };
              break;
      }
      return { value, icon };
  }
  return value;
}


// must export a default object with all the functions to be used by this page
export default {
  formatGenderSelect,
  formatCurrency,
}`;

export const StringColumnHelpRenders: ComponentSample<'StringColumn'>[] = [
  {
    title: 'String Column Rendering Options',
    description: `You can render a StringColumn as a pill, with a letter avatar, with an icon via a format function, or as a link when a trigger on cell click is added as a child

\`\`\`alert
Try changing the properties of the first column to see the change in rendering with different property combinations
\`\`\`
`,
    page,
    controller,
    exampleId: 'eg-01GRF6W8TCYGM86E2KTNC66CT1',
    clearParentChildren: false,
    height: 340,
    visibleProps: [
      'formatFunction',
      'colorExpression',
      'bgColorExpression',
      'renderLetterAvatar',
      'renderAsPill',
    ],
    item: {
      parent: 'canvasGrid',
      type: 'StringColumn',
      props: {
        label: { type: 'text', value: 'Playground' },
        width: 155,
        updatable: {
          type: 'boolean',
          value: true,
        },
        insertable: {
          type: 'boolean',
          value: true,
        },
        viewAttribute: 'firstName',
        colorExpression: {
          type: 'expression',
          value: 'getReadableColor(getColor($.testAlias.firstName))',
        },
        bgColorExpression: {
          type: 'expression',
          value: 'getColor($.testAlias.firstName)',
        },
        renderAsPill: true,
      },
      itemId: 'playgroundStringColumn',
      children: [],
    },
  },
];
